import React from 'react'
import styled from 'styled-components'

const PopupWrapper = styled.div`
  .sb-popup {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 2000;
    left: 0;
    right: 0;
    background-color: RGBA(237, 235, 235, .6);
    i {
      &:hover {
        color: #D8D2D2;
      }
    }
    .close-action,
    .back-action {
      top: 15px;
    }
    .close-action {
      right: 30px;
      position: absolute;
      text-decoration: none;
      &:hover {
        cursor: pointer;
      }
      i {
        margin-top: 2px;
        color:#3399CC;
        font-size: 30px;
      }
    }
    .back-action {
      left: 15px;
    }
    .window {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      position: relative;
    }
    .container-pop {
      overflow-y: auto;
      padding: 50px;
      margin: 50px auto;
      background: white;
      text-align: center;
      width: fit-content;
      max-width: 900px;
      position: relative;
    }
    .left {
      text-align: left;
    }
    .center {
      text-align: center;
    }
  }
`

const PopupMessage = ({
  closeAction,
  backAction,
  showCloseButton,
  onClose,
  alignText,
  children,
  closeParams
}) => {

  return (
    <PopupWrapper>
      <div className="sb-popup">
        <div className='window'>
          <div className='container-pop'>
            {(closeAction || backAction) && (
              <a
                onClick={() => closeAction(closeParams)}
                className='close-action'
              >
                <i className="icon-close" />
              </a>
            )}
            <div>
              {showCloseButton && (
                <span className='close-action' onClick={onClose}>
                  <i className="icon-close" />
                </span>
              )}
              <div className={alignText}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PopupWrapper>
  )
}

export default PopupMessage
